var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 64,
    viewBox: "0 0 57 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#004359"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.245 10.067V23.13c1.523-.882 3.29-1.389 5.177-1.389 5.712 0 10.342 4.624 10.355 10.332 0 2.86 2.319 5.177 5.178 5.177 2.86 0 5.178-2.318 5.178-5.177v-1.294c0-1.43 1.159-2.59 2.588-2.59 1.43 0 2.59 1.16 2.59 2.59V51.1l-5.007 2.89-.171.086V41.038c-1.524.882-3.291 1.389-5.178 1.389-5.711 0-10.342-4.623-10.354-10.332-.001-2.86-2.319-5.177-5.179-5.177-2.859 0-5.177 2.318-5.177 5.177v1.271c0 1.43-1.159 2.59-2.589 2.59s-2.589-1.16-2.589-2.59V13.043l5.006-2.89.172-.086zm-2.6 28.477c1.423 0 2.577 1.154 2.577 2.577s-1.154 2.577-2.577 2.577c-1.424 0-2.577-1.154-2.577-2.577s1.153-2.577 2.577-2.577zm31.088-18.121c1.423 0 2.577 1.153 2.577 2.576 0 1.424-1.154 2.578-2.577 2.578-1.424 0-2.578-1.154-2.578-2.578 0-1.423 1.154-2.576 2.578-2.576z",
    transform: "translate(-64) translate(-2) translate(2) translate(64)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9bbf3a07f43273b2ab5523986eacaaad.svg";
export { ForwardRef as ReactComponent };